<template>
  <div class="goto_home" @click="gotoHome">
    <van-icon class="icon" name="wap-home" />
    首页
  </div>
</template>

<script>
import { Icon } from 'vant'

export default {
  name: 'GotoHome',
  components: {
    [Icon.name]: Icon
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    gotoHome () {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped lang="scss">
.goto_home {
  position: fixed;
  background-color: #fff;
  color: #888;
  bottom: 150px;
  right: 40px;
  width:120px;
  height:120px;
  border-radius: 50%;
  box-shadow: 0 0 10px #888;
  font-size: 28px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .icon {
    font-size: 42px;
    margin-bottom: 5px;
  }
}
</style>
